import colors from '@assets/theme/base/colors';

const { primary } = colors;

const buttonBase = {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    root: {
      '&:hover, &:focus': {
        outline: `3px solid ${primary.main}`,
      },
      '&:disabled': {
        cursor: 'not-allowed !important',
      },
    },
  },
};

export default buttonBase;
